// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymenthistory_historyTitle__l-Ki0{
    color: var(--referral-black);
    width: 328px;
    margin: 0 auto 20px auto;
}
 .paymenthistory_tabItem__WAhhx{
    cursor: pointer;
    background: var(--white);
    color: var(--referral-black);
    border-radius: 12px;
    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
 }
 .paymenthistory_paymentCardBody__XkE4\\+{
    border-radius: 12px;
    background: var(--white);
    border: 1px solid var(--referral-border-color3);
 }
 .paymenthistory_tabItem__WAhhx.paymenthistory_active__O4PLq{
    background: var(--referral-yelllow);
    color: var(--referral-black);
 }
 .paymenthistory_tabContainer__KHtZx{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
 }
 .paymenthistory_paymentWrapper__hpwQz{ 
    margin: auto;
    background: var(--white);
    padding: 16px 14px;
 }
 .paymenthistory_paymentCardBodyHeader__18S6K{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
 }
 .paymenthistory_paymentCardBodyFirstColumn__E3Jkk{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 15px 10px;
    width: 100%;
 }
 .paymenthistory_paymentCardBodyImage__W3wcL img{
    width: 48px;
    height: 48px;
 }
.paymenthistory_paymentCardBodyText__jRxiP{
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
}
.paymenthistory_paymentCardBodySecondColumn__Uv2jd{
    border-top: 1px solid var(--referral-border-color3);
    padding: 10px;
    width: 100%;
    text-align: center;
}
.paymenthistory_success__mu86L{
    padding: 4px 12px;
    border-radius: 6px;
}
.paymenthistory_unsuccess__RVzgY{
    padding: 0;
    border-radius: 6px;
}
.paymenthistory_paymentCardBodyAmountText__eX2Pg{
    color: var(--referral-gray-shade);
    width: 100%;
    text-align: right;
}
.paymenthistory_paymentCardBodyAmount__Q5BJ8{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    flex-direction: column;
}
.paymenthistory_stickybotspac__8HJnj{
   margin-top: 85px !important;
}
.paymenthistory_chipsticky__s-gGE{
   position: fixed;
   top: 68px;
   width: 100%;
   background: #fff;
   padding-bottom: 8px;

}
.paymenthistory_paymentBoxButton__6ZSH4{
   color: var(--referral-blue-background2);
   margin: auto;
   display: inline-block;
   width: 100%;
   margin-bottom: 10px;
 }
 .paymenthistory_paymentButtonInner__Ci61l{
   color: var(--referral-blue-background2);
   background: var(--white);
   margin: auto;
   display: flex;
   width: 100%;
   border-radius: 40px;
   align-items: center;
   justify-content: center;
   gap: 6px;
   cursor: pointer;
 }
 .paymenthistory_paymentBoxBorder__YUaop{
   border: 2px solid var(--referral-blue-background2);
 }

 .paymenthistory_ritarrow__ZMGOC{
   width: 16px;
   height: 15px;
 }

  
 .paymenthistory_view-all-button__bThS9 {
   background: transparent;
   color: var(--referral-blue-background2);
   border: 2px solid var(--referral-blue-background2);
   border-radius: 24px;
   padding: 10px 20px;
   font-weight: bold;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 6px;
   width: 296px;
   height: 42px;
 }
 
 .paymenthistory_view-all-button__bThS9 .paymenthistory_arrow__ehltg {
   font-size: 16px;
 }`, "",{"version":3,"sources":["webpack://./src/components/PaymentHistory/paymenthistory.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,YAAY;IACZ,wBAAwB;AAC5B;CACC;IACG,eAAe;IACf,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;CACpB;CACA;IACG,mBAAmB;IACnB,wBAAwB;IACxB,+CAA+C;CAClD;CACA;IACG,mCAAmC;IACnC,4BAA4B;CAC/B;CACA;IACG,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;CACX;CACA;IACG,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;CACrB;CACA;IACG,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;CACzB;CACA;IACG,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,WAAW;CACd;CACA;IACG,WAAW;IACX,YAAY;CACf;AACD;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,mDAAmD;IACnD,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;AAC1B;AACA;GACG,2BAA2B;AAC9B;AACA;GACG,eAAe;GACf,SAAS;GACT,WAAW;GACX,gBAAgB;GAChB,mBAAmB;;AAEtB;AACA;GACG,uCAAuC;GACvC,YAAY;GACZ,qBAAqB;GACrB,WAAW;GACX,mBAAmB;CACrB;CACA;GACE,uCAAuC;GACvC,wBAAwB;GACxB,YAAY;GACZ,aAAa;GACb,WAAW;GACX,mBAAmB;GACnB,mBAAmB;GACnB,uBAAuB;GACvB,QAAQ;GACR,eAAe;CACjB;CACA;GACE,kDAAkD;CACpD;;CAEA;GACE,WAAW;GACX,YAAY;CACd;;;CAGA;GACE,uBAAuB;GACvB,uCAAuC;GACvC,kDAAkD;GAClD,mBAAmB;GACnB,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,QAAQ;GACR,YAAY;GACZ,YAAY;CACd;;CAEA;GACE,eAAe;CACjB","sourcesContent":[".historyTitle{\n    color: var(--referral-black);\n    width: 328px;\n    margin: 0 auto 20px auto;\n}\n .tabItem{\n    cursor: pointer;\n    background: var(--white);\n    color: var(--referral-black);\n    border-radius: 12px;\n    gap: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 12px;\n }\n .paymentCardBody{\n    border-radius: 12px;\n    background: var(--white);\n    border: 1px solid var(--referral-border-color3);\n }\n .tabItem.active{\n    background: var(--referral-yelllow);\n    color: var(--referral-black);\n }\n .tabContainer{\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n }\n .paymentWrapper{ \n    margin: auto;\n    background: var(--white);\n    padding: 16px 14px;\n }\n .paymentCardBodyHeader{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n }\n .paymentCardBodyFirstColumn{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 15px 10px;\n    width: 100%;\n }\n .paymentCardBodyImage img{\n    width: 48px;\n    height: 48px;\n }\n.paymentCardBodyText{\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    flex-direction: column;\n    gap: 8px;\n}\n.paymentCardBodySecondColumn{\n    border-top: 1px solid var(--referral-border-color3);\n    padding: 10px;\n    width: 100%;\n    text-align: center;\n}\n.success{\n    padding: 4px 12px;\n    border-radius: 6px;\n}\n.unsuccess{\n    padding: 0;\n    border-radius: 6px;\n}\n.paymentCardBodyAmountText{\n    color: var(--referral-gray-shade);\n    width: 100%;\n    text-align: right;\n}\n.paymentCardBodyAmount{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 8px;\n    flex-direction: column;\n}\n.stickybotspac{\n   margin-top: 85px !important;\n}\n.chipsticky{\n   position: fixed;\n   top: 68px;\n   width: 100%;\n   background: #fff;\n   padding-bottom: 8px;\n\n}\n.paymentBoxButton{\n   color: var(--referral-blue-background2);\n   margin: auto;\n   display: inline-block;\n   width: 100%;\n   margin-bottom: 10px;\n }\n .paymentButtonInner{\n   color: var(--referral-blue-background2);\n   background: var(--white);\n   margin: auto;\n   display: flex;\n   width: 100%;\n   border-radius: 40px;\n   align-items: center;\n   justify-content: center;\n   gap: 6px;\n   cursor: pointer;\n }\n .paymentBoxBorder{\n   border: 2px solid var(--referral-blue-background2);\n }\n\n .ritarrow{\n   width: 16px;\n   height: 15px;\n }\n\n  \n .view-all-button {\n   background: transparent;\n   color: var(--referral-blue-background2);\n   border: 2px solid var(--referral-blue-background2);\n   border-radius: 24px;\n   padding: 10px 20px;\n   font-weight: bold;\n   cursor: pointer;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   gap: 6px;\n   width: 296px;\n   height: 42px;\n }\n \n .view-all-button .arrow {\n   font-size: 16px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyTitle": `paymenthistory_historyTitle__l-Ki0`,
	"tabItem": `paymenthistory_tabItem__WAhhx`,
	"paymentCardBody": `paymenthistory_paymentCardBody__XkE4+`,
	"active": `paymenthistory_active__O4PLq`,
	"tabContainer": `paymenthistory_tabContainer__KHtZx`,
	"paymentWrapper": `paymenthistory_paymentWrapper__hpwQz`,
	"paymentCardBodyHeader": `paymenthistory_paymentCardBodyHeader__18S6K`,
	"paymentCardBodyFirstColumn": `paymenthistory_paymentCardBodyFirstColumn__E3Jkk`,
	"paymentCardBodyImage": `paymenthistory_paymentCardBodyImage__W3wcL`,
	"paymentCardBodyText": `paymenthistory_paymentCardBodyText__jRxiP`,
	"paymentCardBodySecondColumn": `paymenthistory_paymentCardBodySecondColumn__Uv2jd`,
	"success": `paymenthistory_success__mu86L`,
	"unsuccess": `paymenthistory_unsuccess__RVzgY`,
	"paymentCardBodyAmountText": `paymenthistory_paymentCardBodyAmountText__eX2Pg`,
	"paymentCardBodyAmount": `paymenthistory_paymentCardBodyAmount__Q5BJ8`,
	"stickybotspac": `paymenthistory_stickybotspac__8HJnj`,
	"chipsticky": `paymenthistory_chipsticky__s-gGE`,
	"paymentBoxButton": `paymenthistory_paymentBoxButton__6ZSH4`,
	"paymentButtonInner": `paymenthistory_paymentButtonInner__Ci61l`,
	"paymentBoxBorder": `paymenthistory_paymentBoxBorder__YUaop`,
	"ritarrow": `paymenthistory_ritarrow__ZMGOC`,
	"view-all-button": `paymenthistory_view-all-button__bThS9`,
	"arrow": `paymenthistory_arrow__ehltg`
};
export default ___CSS_LOADER_EXPORT___;
